import { render, staticRenderFns } from "./user_profile_collection.vue?vue&type=template&id=13d856d3&scoped=true&"
import script from "./user_profile_collection.vue?vue&type=script&lang=ts&"
export * from "./user_profile_collection.vue?vue&type=script&lang=ts&"
import style0 from "./user_profile_collection.vue?vue&type=style&index=0&id=13d856d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d856d3",
  null
  
)

export default component.exports